const ru_RU = {
    CurrentLanguage:"한국어",
    History: "기록",
    Transition: "전환",
    Help: "도움말",
    License: "사용 약관",
    About: "정보",
    Home: "홈",
    News: "뉴스",
    Tips: "팁",
    Blog: '공식 블로그',
    GitHub: '깃허브',
    Options: "옵션",
    ExpertMode: "고급 모드",

    OK:"OK",
    On: '켜기',
    Off: '꺼짐',
    Random: '랜덤',
    Fixed: '고정',
    Enabled: '활성화',
    Disabled: '비활성화',
    Import: 'Import',
    Export: '내보내기',
    Reset: 'Reset',
    WebGLAcceleration: 'WebGL 가속',
    Model: '모델',
    'Options Import': '옵션 임포트',
    'Options Export': '옵션 내보내기',
    'Fix All': '모두 수정',
    NoiseImportExport: '노이즈 가져오기/내보내기',
    CurrentNoise: '현재 노이즈',
    Operations: '연산',
    OperationsExpertMode: '연산(모바일 장치에서는 가져오기/내보내기가 지원되지 않음)',
    CurrentBackend: '현재 백엔드',
    Generate: '생성',
    Generating: '생성 중...',
    WebGLHelper: 'WebGL을 사용하면 이미지를 더 빠르게 생성할 수 있습니다. 문제가 발생하면 WebGL을 비활성화하세요.',
    Canceled:'취소됨',
    NetworkError:'네트워크 오류',
    LoadingModel: '모델 로딩중...',
    Note: "참고: 이용 약관은 {here}를 참조하세요.",
    Here: "여기",
    OptionsMenu: "옵션 메뉴",
    FailedGenerating:"죄송합니다. 브라우저가 이미지를 생성하지 못한 것 같습니다. {optionmenu}에서 {webgl}을 비활성화한 후 다시 시도하세요.",
    Amaryllis:"아마릴리스 128x128 Ver.170716 (3.8MB)",
    Bouvardia128:"부바디아 128x128 Ver.171123 (9.8MB)",
    Bouvardia256: "부바디아 256x256 Ver.171125 (9.9MB)",
    Camellia: "카멜리아 256x256 Ver.171219 (9.9MB)",
    'Remote Computing': "원격 컴퓨팅",

    'Log In': "로그인",
    'Sign Up': "가입",
    'Log Out': "로그아웃",
    'Add to favorite': "즐겨찾기에 추가",

    'Set Start Image': "시작 이미지 설정",
    'Set End Image': "끝 이미지 설정",
    'Generate Transition': "전환 생성",
    'Generated Images': "생성된 이미지",
    'Generate Multiple Images': "여러 이미지 생성",
    'Load input when clicked': "클릭 시 입력 로드",
    'Load Options': "옵션 로드",
    Back: '뒤로',
    'Perturb Current Noise': '전류 노이즈 퍼트러브',
    Perturb: '퍼터브',
    Apply: '적용',
    Revert: '되돌리다',
    Clear:'지우다',
    Finished:'완료',
    NoiseInterpolationMethod:'노이즈 보간(Interpolation)',

    HairColor:"머리 색깔",
    HairStyle:"헤어 스타일",
    EyeColor:"눈 색깔",
    Blush:"홍당무",
    Smile:"미소",
    OpenMouth:"열린 입",
    Hat:"모자",
    Ribbon:"리본",
    Glasses:"안경",
    DarkSkin:'어두운 피부',
    Year:'스타일',
    Noise:'노이즈',


    Blonde: '금발',
    Brown: '갈색',
    Black: '검은색',
    Blue: '파란색',
    Pink: '핑크',
    Purple: '보라색',
    Green: '녹색',
    Red: '빨강',
    Silver: '실버',
    White: '흰색',
    Orange: '오렌지',
    Aqua: '아쿠아',
    Grey: '회색',
    Yellow: '노란색',
    LongHair: '긴 머리',
    ShortHair: '짧은 머리',
    TwinTail: '쌍둥이 꼬리',
    DrillHair: '드릴 헤어',
    Ponytail: '포니테일',

    LicensePageTitle: '라이선스',
    LicenseLine1: '메이크걸즈모에를 사용하려면 다음 라이선스에 동의하셔야 합니다.',
    LicenseLine2Start: 'MakeGirlsMoe는 비상업적 용도로만 무료로 사용할 수 있습니다.',
    LicenseLine2Link: 'license',
    LicenseLine2Middle: '자세한 내용 상업적 문의는 이곳에 연락해 주세요.',
    LicenseLine2EmailLink: 'Yanghua Jin',
    LicenseLine2End: '.',
    LicenseLine3: '웹 인터페이스의 코드는 GPL v3.0 라이선스에 따라 재배포할 수 있습니다',
    LicenseLine4: '컴파일된 모든 모델 파일은 양화진 개인 소유이며 무단 상업적 사용이 허용되지 않습니다.',

    CrypkoNotification: '이더리움 블록체인에서 인공지능으로 생성된 애니메이션 캐릭터를 획득하고 거래할 수 있는 새로운 프로젝트인 크립코를 출시합니다. {here}를 클릭해 테스트넷에서 크립코 베타를 무료로 플레이하세요.',
    ClickHere: '여기를 클릭하세요'
};
export default ru_RU;



// WEBPACK FOOTER //
// ./src/locale/ru_RU.js